exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hide {\r\n  display: none!important;\r\n}\r\n\r\n.inactive {\r\n  opacity: 0.3;\r\n}\r\n\r\nhtml {\r\n  -webkit-print-color-adjust: exact;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n", ""]);

